export { default } from './WidgetV2';
